module.exports = __webpack_public_path__ + "static/media/Camada_3.38b7b0a6.svg";